/**
 * Hostel Room Service
 * Handles all API calls related to hostel rooms
 */

import { handleApiError } from '../../services/config.js';

const HOSTEL_API_BASE = 'https://api.kaha.com.np/hostel/api/v1/';

export const hostelRoomService = {
  /**
   * Get all rooms for a hostel (v1 format)
   * @param {string} hostelId - The hostel ID
   * @returns {Promise<Array>} Room list
   */
  async getRooms(hostelId) {
    try {
      const url = `${HOSTEL_API_BASE}new-rooms?hostelId=${hostelId}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      return await handleApiError(response);
    } catch (error) {
      console.error('Error fetching rooms:', error);
      throw error;
    }
  },

  /**
   * Get room layout with furniture (v1 format)
   * @param {string} roomId - The room ID
   * @returns {Promise<Object>} Room layout data
   */
  async getRoomLayout(roomId) {
    try {
      const url = `${HOSTEL_API_BASE}new-rooms/${roomId}/layout`;
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      return await handleApiError(response);
    } catch (error) {
      console.error('Error fetching room layout:', error);
      throw error;
    }
  },
};
